export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer"

      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Territories",
      url: "/territories",
      icon: "icon-location-pin"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Maps",
      url: "/maps",
      icon: "fa fa-globe",
      children: [
        {
          name: "Territory",
          url: "/maps"
        },
        {
          name: "Cluster",
          url: "/rotation-maps"
        },
        {
          name: "Query By Zip",
          url: "/zipcode-map"
        }
      ]
    },
    {
      name: "Seminars",
      url: "/seminars",
      icon: "fa fa-handshake-o"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Territory Checks",
      url: "/TerritoryChecks",
      icon: "icon-location-pin",
      children: [
        {
          name: "Checks",
          url: "/TerritoryChecks"
        },
        {
          name: "Check Map",
          url: "/check-maps"
        },
        {
          name: "Check Cluster Map",
          url: "/rotation-check-maps"
        },
        {
          name: "By Zip With Checks",
          url: "/zipcode-map-checks"
        }
      ]
    },
    // {
    //   name: "Restaurants",
    //   url: "/restaurants",
    //   icon: "fa fa-building"
    // },
    {
      name: "Setup",
      url: "/restaurants",
      icon: "icon-wrench",
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/

      children: [
        {
          name: "Artwork Types",
          url: "/artwork",
          icon: "icon-layers"
        },
        {
          name: "Cuisine Types",
          url: "/cuisines",
          icon: "icon-menu"
        },
        {
          name: "Restaurants",
          url: "/restaurants",
          icon: "fa fa-building"
        },
        {
          name: "Vendors",
          url: "/vendors",
          icon: "fa fa-dollar"
        },
        {
          name: "Contacts",
          url: "/contacts",
          icon: "fa fa-id-card"
        },
        {
          name: "Filters",
          url: "/filters",
          icon: "fa fa-filter"
        }
      ]
    }
    /*,
    {
      name: "Reports",
      url: "/inventory",
      icon: "fa fa-bar-chart"
    }*/
  ]
};
